function Validation(email, password) { 
  let error = {};
  const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const password_pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,}$/;

  if (email === "") {
    error.email = "Name shouldn't be empty";
  } else if (!email_pattern.test(email)) {
    console.log("email", email);
    error.email = "email didn't match";
  } else {
    error.email = "";
  }

  if (password === "") {
    error.password = "password shouldn't be empty";
  } else {
    error.password = "";
  }
  return error;
}

export default Validation;
